import api from "../api";
import { useEffect, useRef, useState } from "react";

const useFetchIntegrations = () => {
  const [integrations, setIntegrations] = useState([]);

  const fetchIntegrations = async () => {
    const { data } = await api.get("/api/integrations");
    setIntegrations(data);
  };

  const fetchCalledRef = useRef(false);

  useEffect(() => {
    if (!fetchCalledRef.current) {
      fetchCalledRef.current = true;
      fetchIntegrations();
    }
  }, []);

  return { integrations };
};

export default useFetchIntegrations;
